import '@/scripts/helpers/passive-scroll';
import "slick-carousel/slick/slick";
import lottie from "lottie-web";
import { animationData } from "@/scripts/animation-data/animatedSignatureLight";
import { animatedExample } from "@/scripts/animation-data/animatedExample";
import { animateIntroSignature } from "@/scripts/animation-data/animateIntroSignature";
import { CLASSES } from "@/scripts/helpers/constants";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import { bindJQuery } from "@/scripts/helpers/library";
import { initLoader, hideLoader } from "@/modules/loader/loader";
import {
  attachFeaturesSliderHelper,
  initFeaturesSlider
} from "@/scripts/pages/home/features-slider";
import video from "@/modules/accessability-exp-10743/video/video";
import Accordion from "@/modules/containers/accordion";
import modalShow from "@/modules/containers/modal/modal";
import contactForm from "@/modules/blocks/contact-form/index";
import sendMyDocument from "@/sections/loading-documents/index";
import { switchPriceHandler, setPlanButtonUrl } from "@/modules/pricing-block/index";

const videoClass = ".js-ready-video",
      animateClass = ".js-ready-animate",
      animateClassExample = ".js-ready-animate-example",
      animateClassIntroSignature = ".js-ready-animate-intro-signature";

let videoWasPlayedFlag = false,
    animateWasPlayedFlag = false,
    animateWasPlayedFlag2 = false,
    animateWasPlayedFlag3 = false;

const inView = function(element) {
  const win = $(window),
        obj = element,
        scrollPosition = win.scrollTop(),
        visibleArea = win.scrollTop() + win.height(),
        objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const dataAnimateIntroSignature = () => {
  let params = {
    container: document.getElementById("animateIntroSignature"),
    renderer: "svg",
    loop: false,
    autoplay: true,
    animationData: animateIntroSignature
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const startAnimateIntroSignature = () => {
  const animateIntroSignature = document.querySelector(animateClassIntroSignature);

  if (animateIntroSignature !== null) {
    if (!animateWasPlayedFlag3 && inView($(animateIntroSignature))) {
      dataAnimateIntroSignature();
      animateWasPlayedFlag3 = true;
    }

    window.addEventListener("scroll", event => {
     if (!animateWasPlayedFlag3 && inView($(animateIntroSignature))) {
        dataAnimateIntroSignature();
        animateWasPlayedFlag3 = true;
      }
    });
  }

  setTimeout(() => {
    $("#animateIntroSignature").remove();
    $(".js-ready-animate-intro-signature").addClass(CLASSES.IS_VISIBLE);
  }, 1200);
};

const loadVideo = () => {
  const lazyVideos = [].slice.call(document.querySelectorAll(videoClass));

  lazyVideos.forEach(function(lazyVideo) {
    lazyVideo.children[0].src = lazyVideo.children[0].dataset.src;
    lazyVideo.load();
  });
};

const playVideo = () => {
  const video = document.querySelector(videoClass);

  if (video !== null) {
    loadVideo();

    window.addEventListener("scroll", event => {
      if (!videoWasPlayedFlag && inView($(video))) {
        video.play();
        videoWasPlayedFlag = true;
      }
    });
  }
};

const dataAnimationExample = () => {
  let params = {
    container: document.getElementById("animatedSignatureExample"),
    renderer: "svg",
    loop: true,
    autoplay: true,
    animationData: animatedExample
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const dataAnimation = () => {
  let params = {
    container: document.getElementById("animatedSignature"),
    renderer: "svg",
    loop: false,
    autoplay: true,
    animationData: animationData
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const startAnimation = () => {
  const animate = document.querySelector(animateClass),
    animateExample = document.querySelector(animateClassExample);

  if (animateExample !== null) {
    window.addEventListener("scroll", event => {
      if (!animateWasPlayedFlag2 && inView($(animateExample))) {
        dataAnimationExample();
        animateWasPlayedFlag2 = true;
      }
    });
  }

  if (animate !== null) {
    window.addEventListener("scroll", event => {
      if (!animateWasPlayedFlag && inView($(animate))) {
        dataAnimation();
        animateWasPlayedFlag = true;
      }
    });
  }
};

const reviewSlider = () => {
  const slickElement = $(".js-review-slider-viewport"),
    nextArrow = $(".js-slider-arrow .btn-next-arrow"),
    prevArrow = $(".js-slider-arrow .btn-prev-arrow"),
    sliderSingle = $(".js-review-slider-viewport");

  slickElement.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (counter === 1) {
      prevArrow.attr("tabindex", "-1");
    } else {
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    }
  });

  slickElement.slick({
    infinite: true,
    slidesToShow: 1,
    speed: 600,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    adaptiveHeight: true,
    swipeToSlide: false,
    swipe: false,
    dsf: false,
    fade: true,
    dots: true,
    responsive: [
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          centerMode: false
        }
      }
    ]
  });

  slickElement.on("afterChange", function() {
    $(".slick-list").removeClass("is-open");
  });

  $(".slick-list").attr("aria-live", "polite");

  nextArrow.click(function(e) {
    sliderSingle.slick("slickNext");
  });
  prevArrow.click(function(e) {
    sliderSingle.slick("slickPrev");
  });
};

const compareTabletHeader = () => {
  const overflowBlock = $(".table-wrapper");

  overflowBlock.scroll(function() {
    let position = $(this).scrollLeft();
    const tableTheadSticky = $(".services-comparison-table__thead.is-sticky");

    if (tableTheadSticky.length) {
      const compareHeader = ".services-comparison-table__thead .row";
      let compareHeaderWidth = $(compareHeader).width();
      $(compareHeader).css("left", "-" + position + "px");
      $(compareHeader).css("width", compareHeaderWidth + "px");
    }
  });
};

$(window).scroll(function() {
  let position = $(".table-wrapper").scrollLeft();
  const tableTheadSticky = $(".services-comparison-table__thead.is-sticky"),
    compareHeader = $(".services-comparison-table__thead .row");

  if (tableTheadSticky.length !== 1) {
    compareHeader.removeAttr("style");
  }
  if (tableTheadSticky.length) {
    compareHeader.css("left", "-" + position + "px");
  }
});

function stickyTableHeader() {
  const targetWidth = $(".services-comparison-table__tbody").width();

  $(window).scroll(function() {
    const fromTop = window.pageYOffset,
      tableHeader = $(".services-comparison-table__thead"),
      startPoint = $(".js-services-comparison-table"),
      offsetTop = startPoint.offset().top,
      offsetBottom = startPoint.innerHeight(),
      stopPoint = offsetTop + offsetBottom,
      tabletBreakpoint = 960,
      windowWidth = $(window).width();

    var marginTop = 0;
    const headerSticky = $(".pinned-header");

    if (headerSticky && tabletBreakpoint < windowWidth) {
      marginTop = 76;
    } else {
      marginTop = 76;
    }

    if (
      fromTop >= offsetTop - marginTop &&
      fromTop <= stopPoint - (marginTop + tableHeader.height())
    ) {
      tableHeader.addClass("is-sticky");
      startPoint.addClass("is-active");
    } else {
      tableHeader.removeClass("is-sticky");
      startPoint.removeClass("is-active");
    }
  });

  $(".services-comparison-table__thead").css("max-width", targetWidth);

  if ($(".row-price").length === 1) {
    $(".services-comparison-table__tbody").addClass("single-price");
  }

  if (!$(".row-price").length) {
    $(".services-comparison-table__tbody").addClass("no-price");
  }
}

const howToSlider = () => {
  const nextArrow = $(".how-to-sign-slider-navigation__arrow--next"),
    prevArrow = $(".how-to-sign-slider-navigation__arrow--prev"),
    slickElement = $(".js-how-to-sign-slider");

  slickElement.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      nextArrow.addClass("is-disable");
      nextArrow.attr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    } else {
      nextArrow.removeClass("is-disable");
      nextArrow.removeAttr("tabindex", "-1");
      prevArrow.removeClass("is-disable");
      prevArrow.removeAttr("tabindex", "-1");
    }
  });

  slickElement.slick({
    infinite: false,
    slidesToShow: 1,
    speed: 600,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    adaptiveHeight: true,
    swipeToSlide: false,
    swipe: false,
    dsf: false,
    fade: true,
    dots: true,
    responsive: [
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          centerMode: false
        }
      }
    ]
  });

  nextArrow.click(function(e) {
    e.preventDefault();
    slickElement.slick("slickNext");
  });

  prevArrow.click(function(e) {
    e.preventDefault();
    slickElement.slick("slickPrev");
  });
};

const toolkitSlider = () => {
  const params = {
    initToolkitSlider: $(".toolkit-slider"),
    statusToolkit: $(".js-slide-counter-toolkit"),
    nextArrow: $(".js-toolkit-slider-arrow .btn-next-arrow"),
    prevArrow: $(".js-toolkit-slider-arrow .btn-prev-arrow"),
    signIllustration: $(".sign-illustration"),
    tabletBreakpoint: 959
  };

  params.initToolkitSlider.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1,
      sumCouner = slick.$dots[0].children.length;

    if (sumCouner < 10) {
      params.statusToolkit.html(
        "<b>0" + counter + "</b> " + "&nbsp;/&nbsp;0" + sumCouner
      );
    } else if (counter < 10) {
      params.statusToolkit.html(
        "<b>0" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner
      );
    } else {
      params.statusToolkit.html(
        "<b>" + counter + "</b> " + "&nbsp;/&nbsp;" + sumCouner
      );
    }

    if (counter === 1) {
      params.prevArrow.addClass("is-disable");
      params.prevArrow.attr("tabindex", "-1");
    } else if (counter === sumCouner) {
      params.nextArrow.addClass("is-disable");
      params.nextArrow.attr("tabindex", "-1");
      params.prevArrow.removeClass("is-disable");
      params.prevArrow.removeAttr("tabindex", "-1");
    } else {
      params.nextArrow.removeClass("is-disable");
      params.nextArrow.removeAttr("tabindex", "-1");
      params.prevArrow.removeClass("is-disable");
      params.prevArrow.removeAttr("tabindex", "-1");
    }
  });

  params.initToolkitSlider.slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 600,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: "ondemand",
    fade: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 959,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  params.initToolkitSlider.on("afterChange", function() {
    params.signIllustration.css("display", "block");
    $(".slick-list").removeClass("is-open");
    if ($(window).width() > params.tabletBreakpoint) {
      $(".toolkit-nav").css({ top: "" });
    }
  });

  params.initToolkitSlider.on("beforeChange", function() {
    params.signIllustration.css("display", "none");
  });

  params.nextArrow.click(function(e) {
    params.initToolkitSlider.slick("slickNext");
  });
  params.prevArrow.click(function(e) {
    params.initToolkitSlider.slick("slickPrev");
  });

  $(".toolkit-nav").css("width", $(".sign-illustration").width());

  if ($(window).width() < params.tabletBreakpoint) {
    $(".toolkit-nav").css(
      "top",
      $(".page-section__column--media").outerHeight(true)
    );
  }

  $(window).resize(function() {
    $(".toolkit-nav").css("width", $(".sign-illustration").width());

    if ($(window).width() < params.tabletBreakpoint) {
      $(".toolkit-nav").css(
        "top",
        $(".page-section__column--media").outerHeight(true)
      );
    }
  });
};

const handleFullscreenHelpers = () => {
  const header = $("body");

  if (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
  ) {
    if (header.length) header.addClass("frame-fulscreen");
  } else {
    header.removeClass("frame-fulscreen");
  }
};

const disableFirstScreenAnimation = () => {
  var numberOfSessions = 1;
  var getNumberOfSessions = Number(localStorage.getItem("number_of_sessions"));

  if(getNumberOfSessions >= 5) {
    $(".page-section--intro-v2").removeClass("js-ready-animate-intro-signature");
    $("#animateIntroSignature").remove();
    $(".page-section--intro-v2").addClass(CLASSES.IS_VISIBLE);
  } else {
    var numberOfSessions = getNumberOfSessions + 1;
    localStorage.setItem("number_of_sessions", numberOfSessions);
  }
};

bindJQuery();

$(function() {
  initWowLibrary();
  addedLazyLoadImages();
  sendMyDocument();
  attachFeaturesSliderHelper();
  initFeaturesSlider();
  playVideo();
  video();
  reviewSlider();
  compareTabletHeader();
  stickyTableHeader();
  Accordion();
  howToSlider();
  toolkitSlider();
  disableFirstScreenAnimation();
  startAnimation();
  startAnimateIntroSignature();
  modalShow();
  contactForm();
  switchPriceHandler();
  setPlanButtonUrl();

  $(window).resize(handleFullscreenHelpers);

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });
});

window.addEventListener("pagehide", function() {
  if ($(".loader-wrapper").length) {
    hideLoader($(".loader"));
  }
});

window.addEventListener("pageshow", function(evt) {
  if (evt.persisted) {
    setTimeout(function() {
      window.location.reload();
    }, 10);
  }
}, false);
